import { mapGetters, mapActions } from 'vuex'
import { generateEmailTemplateListById } from './emailTemplates'
import { clone } from 'ramda'

export const windowWidthGetter = {
  data () {
    return {
      windowWidthGetter_width: null
    }
  },
  methods: {
    $_windowWidthGetter_updateWindowWidth () {
      this.windowWidthGetter_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    }
  },
  mounted () {
    this.$_windowWidthGetter_updateWindowWidth()
    window.addEventListener('resize', this.$_windowWidthGetter_updateWindowWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.$_windowWidthGetter_updateWindowWidth)
  }
}

export const submitGlobalStyles = {
  watch: {
    currentSettings: {
      deep: true,
      handler (newVal) {
        this.settings = clone(newVal)
      }
    }
  },
  methods: {
    ...mapActions(['submitStyleSettings']),
    async generateSubmit (key) {
      const payload = {
        key,
        settings: this.settings
      }
      await this.submitStyleSettings(payload)
    },
    resetSettings () {
      this.settings = clone(this.currentSettings)
    }
  },
  created () {
    this.resetSettings()
  }
}

/**
 * mixin which checks if user have persmission to delete, update, create data
 * your component must have 'scopeForWrite' property in data which specifies necessary scope for write operations
 * example:
 * scopeForWrite: 'awards:write'
 */
export const isWriteAvailable = {
  data () {
    return {
      scopeForWrite: 'admin'
    }
  },
  computed: {
    ...mapGetters({
      userScopesList: 'userScopes'
    }),
    isWriteAvailable () {
      return this.userScopesList.includes(this.scopeForWrite)
    }
  }
}

export const emailTemplates = {
  computed: {
    ...mapGetters({
      getEmailTemplates: 'getEmailTemplates'
    }),
    vipInvitationTemplatesList: generateEmailTemplateListById(
      'vipRegistrationInvitation',
      this.getEmailTemplates
    ),
    registrationSuccesTemplatesList: generateEmailTemplateListById(
      'registrationSuccess',
      this.getEmailTemplates
    ),
    registrationFailtureTemplatesList: generateEmailTemplateListById(
      'registrationFailture',
      this.getEmailTemplates
    ),
    blitzInvitationTemplatesList: generateEmailTemplateListById(
      'blitzInvitation',
      this.getEmailTemplates
    ),
    listingInvitationTemplatesList: generateEmailTemplateListById(
      'listingInvitation',
      this.getEmailTemplates
    ),
    featuredAttendeeInvitationTemplatesList: generateEmailTemplateListById(
      'featuredAttendeeInvitation',
      this.getEmailTemplates
    ),
    multipleTicketsSuccessBuyTemplatesList: generateEmailTemplateListById(
      'multipleTicketsSuccessBuy',
      this.getEmailTemplates
    ),
    multipleTicketsFailedBuyTemplatesList: generateEmailTemplateListById(
      'multipleTicketsFailedBuy',
      this.getEmailTemplates
    ),
    requestForPaymentTemplatesList: generateEmailTemplateListById(
      'requestForPayment',
      this.getEmailTemplates
    ),
    requestForPhotoTemplatesList: generateEmailTemplateListById(
      'requestForPhoto',
      this.getEmailTemplates
    ),
    adminNotificationsTemplatesList: generateEmailTemplateListById(
      'adminNotifications',
      this.getEmailTemplates
    ),
    attendeeNotificationsTemplatesList: generateEmailTemplateListById(
      'attendeeNotifications',
      this.getEmailTemplates
    ),
    registrationCompanyUpdatesTemplatesList: generateEmailTemplateListById(
      'registrationCompanyUpdates',
      this.getEmailTemplates
    ),
    registrationProductUpdatesTemplatesList: generateEmailTemplateListById(
      'registrationProductUpdates',
      this.getEmailTemplates
    ),
    attendeeBlockedMessageTemplatesList: generateEmailTemplateListById(
      'attendeeBlockedMessage',
      this.getEmailTemplates
    ),
    mediaKitTemplatesList: generateEmailTemplateListById(
      'mediaKit',
      this.getEmailTemplates
    ),
    remindTemplatesList: generateEmailTemplateListById(
      'remind',
      this.getEmailTemplates
    ),
    attendeeConfirmationTemplatesList: generateEmailTemplateListById(
      'attendeeConfirmation',
      this.getEmailTemplates
    ),
    attendeeMessageTemplatesList: generateEmailTemplateListById(
      'attendeeMessage',
      this.getEmailTemplates
    ),
    blitzSubmittedTemplatesList: generateEmailTemplateListById(
      'blitzSubmitted',
      this.getEmailTemplates
    ),
    contactUsTemplatesList: generateEmailTemplateListById(
      'contactUs',
      this.getEmailTemplates
    ),
    enableVideoRequestTemplatesList: generateEmailTemplateListById(
      'enableVideoRequest',
      this.getEmailTemplates
    ),
    invoiceRefundSendingTemplatesList: generateEmailTemplateListById(
      'invoiceRefundSending',
      this.getEmailTemplates
    ),
    IPNRefundSendingTemplatesList: generateEmailTemplateListById(
      'IPN',
      this.getEmailTemplates
    ),
    IPNTemplatesList: generateEmailTemplateListById(
      'IPN',
      this.getEmailTemplates
    ),
    listingSubmittedTemplatesList: generateEmailTemplateListById(
      'listingSubmitted',
      this.getEmailTemplates
    ),
    invoicesTemplatesList: generateEmailTemplateListById(
      'invoices',
      this.getEmailTemplates
    ),
    forgotPasswordRequestTemplatesList: generateEmailTemplateListById(
      'forgotPasswordRequest',
      this.getEmailTemplates
    )
  }
}

export default {
  isWriteAvailable,
  emailTemplates,
  submitGlobalStyles
}



// WEBPACK FOOTER //
// ./src/utils/mixins.js